module.exports = __webpack_public_path__ + "img/TextBlockWithImageGrid.ada24b45.png";